import React, {useState} from "react";
import DetailOrder from "@components/DetailOrder/DetailOrder";
import {Modal, Table} from "antd";
import Lang from "@components/Lang/Lang";
import HoverIcon from "@components/HoverIcon";
import "./DetailCustomer.less";
import InventoryQueryService from "@services/InventoryQuerySerivce";
import Locale from "@utils/locale";

let locale = Locale.current();

/**
 * 客户详情
 * @param {Object} props 组件属性
 * @returns {JSX.Element}
 * @constructor
 */
const DetailCustomer = (props) => {
    /**
     * 客户资料
     */
    const [customer, setCustomer] = useState({});

    /**
     * 计量单位
     */
    const Xiang = Lang({id: "Xiang", default: "箱"});

    /**
     * 模态框（可见状态）
     */
    const [isModalVisible, setIsModalVisible] = useState(false);

    /**
     * 模态框（显示）
     */
    const showModal = () => {
        InventoryQueryService.queryDetail({
            buyerId: props.buyerId
        }).then(resp => {
            let data = resp.data;
            if (data.success && data.valid) {
                setCustomer(data.model);
                setIsModalVisible(true);
            }
        })
    };


    /**
     * 模态框（关闭）
     */
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    /**
     * 表格栏目
     *
     * @type {[{dataIndex: string, title, render: (function(*)), key: string}, {dataIndex: string, title}, {dataIndex: string, title}, {dataIndex: string, title}, {dataIndex: string, title: string}]}
     */
    const columns = [
        {
            title: Lang({id: "DingDan", default: "订单"}),
            dataIndex: "poCode",
            render: (poCode, record) => {
                return <DetailOrder poCode={poCode} poId={record.poId} customer={customer}/>
            }
        },
        {
            title: Lang({id: "ZhuangTai", default: "状态"}),
            dataIndex: "typeName",
        },
        {
            title: Lang({id: "ShouHuoRen", default: "收货人"}),
            dataIndex: "consigneeVO",
            render: (consigneeVO) => {
                return <>
                    <div className="primary-text">{consigneeVO.consigneeName} +{consigneeVO.telCode} {consigneeVO.consigneeMonde}</div>
                    <div className="secondary-text">
                        {locale !== "zh" ? (
                            <span>{consigneeVO.country}&nbsp;{consigneeVO.consigneeAddress}&nbsp;{consigneeVO.city}&nbsp;{consigneeVO.province}</span>
                        ) : (
                            <span>{consigneeVO.country}&nbsp;{consigneeVO.province}&nbsp;{consigneeVO.city}&nbsp;{consigneeVO.consigneeAddress}</span>
                        )}
                    </div>
                </>
            }
        },
        {
            title: Lang({id: "ShangPinKuanChu", default: "商品款数"}),
            dataIndex: "itemCount",
        },
        {
            title: Lang({id: "KuCun", default: "库存"}) + `(${Xiang})`,
            dataIndex: "boxCount",
        },
    ];

    return (
        <div className="DetailCustomer">
            {/* 按钮 */}
            <span onClick={showModal}>
                <HoverIcon inactiveIcon="icon-xiangqing-moren-icon" activeIcon="icon-xiangqing-xuanzhong-icon"/>
            </span>
            {/* 模态框 */}
            <Modal className="DetailCustomer__modal" width="70%" title={Lang({id: "XiangQing", default: "详情"})} footer={null} open={isModalVisible} onCancel={handleCancel}>
                <div className="customer-info">
                    <h2><Lang id="KeHuBianHao">客户编号</Lang> {customer.buyerCode} </h2>
                    <small>{customer.email}</small>
                    <small>+{customer.telCode} {customer.mobile}</small>
                </div>
                {/* 数据列表 */}
                <Table dataSource={customer.itemList} columns={columns} rowKey="poId" pagination={false}/>
            </Modal>
        </div>
    );
};

export default DetailCustomer;
